import {
  collection,
  getDocs,
  doc,
  writeBatch,
} from "firebase/firestore";

import { db } from "../firebase/firebase";


export async function migrateOldReviews() {
  try {
    console.log("=================================");
    console.log("OLD REVIEW MIGRATION STARTED");
    console.log("=================================");

    const snapshot = await getDocs(
      collection(db, "reviews")
    );

    console.log(
      `Total documents found: ${snapshot.size}`
    );

    if (snapshot.empty) {
      alert("No reviews found.");
      return;
    }

    const documentsToMigrate = [];

    snapshot.forEach((reviewDoc) => {
      const oldData = reviewDoc.data();

      // Do not migrate records that are already in the new format
      if (
        oldData.overallExperience !== undefined ||
        oldData.migratedFromLegacy === true
      ) {
        console.log(
          `Skipping already migrated: ${reviewDoc.id}`
        );
        return;
      }

      const rating = Number(oldData.rating);

      /*
       * Old records already have a single overall rating.
       *
       * We use that same rating for every new
       * feedback category.
       *
       * Example:
       * old rating = 5
       *
       * All new rating fields = 5
       */
      const migratedRating =
        rating >= 1 && rating <= 5 ? rating : 5;

      documentsToMigrate.push({
        id: reviewDoc.id,

        data: {
          // -------------------------
          // Basic information
          // -------------------------

          name: oldData.name || "",

          // -------------------------
          // New feedback ratings
          // -------------------------

          overallExperience: migratedRating,

          culturalPrograms: migratedRating,

          organization: migratedRating,

          cleanliness: migratedRating,

          parking: migratedRating,

          hospitality: migratedRating,

          volunteers: migratedRating,

          crowdManagement: migratedRating,

          foodPrasada: migratedRating,

          volunteerImprovement: migratedRating,

          meaningfulProgram: migratedRating,

          // -------------------------
          // Communication
          // -------------------------

          communicationChannel:
            "Not recorded",

          // -------------------------
          // Old written feedback
          // -------------------------

          otherFeedback:
            oldData.review ||
            oldData.comments ||
            "",

          // Preserve old comments separately
          legacyComments:
            oldData.comments || "",

          // -------------------------
          // Existing timestamp
          // -------------------------

          createdAt:
            oldData.createdAt || null,

          // -------------------------
          // Migration marker
          // -------------------------

          migratedFromLegacy: true,
        },
      });
    });

    console.log(
      `Documents to migrate: ${documentsToMigrate.length}`
    );

    if (documentsToMigrate.length === 0) {
      alert(
        "No old reviews need migration."
      );
      return;
    }

    /*
     * Firestore batch limit is 500.
     * We use 400 for safety.
     */
    const BATCH_SIZE = 400;

    for (
      let start = 0;
      start < documentsToMigrate.length;
      start += BATCH_SIZE
    ) {
      const chunk =
        documentsToMigrate.slice(
          start,
          start + BATCH_SIZE
        );

      const batch = writeBatch(db);

      chunk.forEach((item) => {
        batch.update(
          doc(db, "reviews", item.id),
          item.data
        );
      });

      await batch.commit();

      console.log(
        `Migrated ${Math.min(
          start + BATCH_SIZE,
          documentsToMigrate.length
        )} / ${documentsToMigrate.length}`
      );
    }

    console.log("=================================");
    console.log("MIGRATION COMPLETED");
    console.log("=================================");

    alert(
      `Migration completed successfully!\n\n${documentsToMigrate.length} old reviews migrated.`
    );
  } catch (error) {
    console.error(
      "Review migration failed:",
      error
    );

    alert(
      "Migration failed. Check the browser console."
    );
  }
}